import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleUser } from '@fortawesome/free-solid-svg-icons';
import MessageErrorModal from '../../../ui/Modals/MessageErrorModal';
import ErrorMessageOcrModal from '../../../ui/Modals/ErrorMessageOcrModal';
import IconAwesomeCheckCircle from '../../../assets/new-icons/ionic-ios-checkmark-circle-outline.svg';
import IconPerson from '../../../assets/new-icons/icon-min.png';
import { setCustomGuestId, setGuestHolder, setSelectedGuest } from '../guestsSlice';
import { useLoginMutation } from '../../../services/ocrApi';
import { setErrorMessage, setIsLoading } from '../../../app/store/majesticSlice';
import { setToken } from '../../../app/store/ocrSlice';
import usePageNavigation from '../../../hooks/usePageNavigation';


function BookingPage(
  {
    guestId,
    guestTypeId,
    guestName,
    guestLastName,
    guestNumber,
    guestCheckIn,
    guestNumberClient,
  },
) {
  const { guestList, guestHolder } = useSelector((state) => state.guests);
  const [login, {
    data, isSuccess, isError, error,
  }] = useLoginMutation();
  const [guestType, setGuestType] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { navigateNextPage } = usePageNavigation();

  // useEffect(() => {
  //   if (guestTypeId !== '') {
  //     setGuestType(guestsType.find((item) => item.typeId === parseInt(guestTypeId, 10)));
  //   }

  //   return () => {
  //     dispatch(setIsLoading(false));
  //   };
  // }, [dispatch, guestTypeId]);

  useEffect(() => {
    const handleSuccess = async () => {
      if (isSuccess) {
        try {
          dispatch(setToken(data.token));
          dispatch(setCustomGuestId(guestId));
          // navigate('/DocumentFront');
          navigateNextPage('DocumentFront');
        } catch (error) {
          console.error('Error en handleSuccess:', error);
        }
      }
    };

    handleSuccess();
  }, [navigateNextPage, dispatch, data, isSuccess, guestId]);

  const selectedGuest = () => {
    if (guestList.length > 0) {
      const findedGuest = guestList.find((item) => item.customId === guestId);
      // console.log(findedGuest)
      if (typeof findedGuest !== 'undefined') {
        dispatch(setSelectedGuest(findedGuest));
      }
    }
  };

  const handleSelectedGuest = async () => {
    // const findedGuestHolder = guestList.find((item) => item.NumeroCliente === '01');
    // if (typeof findedGuestHolder === 'undefined') {
    //   dispatch(setErrorMessage({ message: t('TXT_WARNING_NOT_FINDED_GUEST_HOLDER') }));
    //   return;
    // }

    // // Stop run
    if (['2', '3'].includes(guestTypeId) && (guestHolder.IDHuesped === '' || guestHolder.EMail === '')) {
      dispatch(setErrorMessage({ message: t('TXT_WARNING_NO_COMPLETED_HOLDER', { holderName: guestHolder.Nombre_Pila }) }));
      return;
    }

    // dispatch(setGuestHolder(findedGuestHolder));

    dispatch(setIsLoading(true));
    await login().unwrap().catch((err) => {
      // console.log(err);
      // setShowErrorModal(true); // Mostrar el modal de error
      // setErrorMessage(err.data?.message || 'Ocurrió un error al obtener los huéspedes.'); // Extraer el mensaje de error
    });

    selectedGuest();
  };

  const handleDocumentationEdit = () => {
    dispatch(setCustomGuestId(guestId));
    selectedGuest();
    // navigate('/DocumentationEdit');
    navigateNextPage('DocumentationEdit');
  };

  return (
    <Card
      className={`uest__card app-border-granite-80-light rounded-3 ${guestCheckIn !== '' ? 'checkin-completed' : ''}`}
      data-type={guestTypeId}
    >
      <Card.Body className="">
        <div className="d-flex">
          <div className="guest my-auto pe-3">
            {/* <FontAwesomeIcon className="app-txt-gray" size="3x" icon={faCircleUser} /> */}
            <img src={IconPerson} alt="iconPerson" className="img-fluid-33" />
          </div>
          <div className="flex-fill">
            <div className="d-flex">
              {(guestName !== '' || guestLastName !== '') && (
                <p className="mb-0 flex-fill app-txt-granite-80-dark app-fw-notosans-bold app-fs-14">
                  {guestName}
                  {' '}
                  {guestLastName}
                </p>
              )}
              {guestLastName === '' && guestName === '' && (
                <p className="mb-0 app-fw-segoe-bold app-txt-gold flex-fill">
                  {'\u00A0'}
                </p>
              )}
            </div>
            <div className="d-flex">
              <div className="flex-fill">
                <p className="mb-0 app-fs-12 app-txt-gray d-inline-block">
                  {t(`TXT_GUEST_${guestTypeId}`)}
                  <span>
                    {' '}
                    {guestNumberClient}
                  </span>
                  <span> | </span>
                  <span>{ t(`TXT_BETWEEN_YEARS_PERSON_TYPE_0${guestTypeId}`) }</span>
                </p>
                {/* <p className="mb-0 app-fs-12 app-txt-gray d-k">
                  { t(`TXT_BETWEEN_YEARS_PERSON_TYPE_0${guestTypeId}`) }
                </p> */}
              </div>
            </div>
            <div className="d-flex mt-2">
              {guestCheckIn === '' && (
                <Button
                  onClick={handleSelectedGuest}
                  variant=""
                  className="app-bg-sand app-txt-granite app-fs-12 app-fw-notosans-bold rounded-3 btn-opacity-sand border-0"
                >
                  <span className="text-uppercase">Check in</span>
                </Button>
              )}

              {guestCheckIn !== '' && (
                <Button
                  variant=""
                  className="mb-0 app-fs-12 ps-0 app-fw-segoe-bold"
                >
                  <img src={IconAwesomeCheckCircle} alt="IconAwesomeCheckCircle" style={{ width: '20px' }} />
                  <span className="app-fw-notosans-bold  align-middle ps-1">{t('TXT_CHECKIN_GUEST_COMPLETE')}</span>
                </Button>
              )}

              {guestCheckIn !== '' && (
                <Button
                  onClick={handleDocumentationEdit}
                  variant=""
                  // className="btn bg-transparent app-txt-red app-fs-12 app-fw-segoe-bold float-nd p-0 border-0 text-decoration-underline"
                  className="app-bg-sand app-txt-granite app-fs-12 app-fw-notosans-bold rounded-3 me-3 btn-opacity-sand border-0"
                >
                  <span className="text-uppercase">{t('TXT_BTN_VIEW')}</span>
                </Button>
              )}
            </div>
          </div>
        </div>
      </Card.Body>

      {/* {isError && <MessageErrorModal message={error.message} />} */}
      {isError && <ErrorMessageOcrModal />}
    </Card>
  );
}

export default BookingPage;
